import { Modal, Tabs, Typography } from 'antd';
import type { IERPUser } from '@admin-panel/types';
import { useReleaseIdentifier } from '@admin-panel/hooks';
import AccountSettings from './AccountSettings';
import GeneralSettingsContent from './GeneralSettingsContent';
import * as Styles from './styles';

interface SettingsModalProps {
  open: boolean;
  onClose: () => void;
  user?: IERPUser;
}

const SettingsModal = ({ open, onClose, user }: SettingsModalProps) => {
  const { release } = useReleaseIdentifier();

  const items = [
    {
      key: 'general',
      label: 'General',
      children: <GeneralSettingsContent user={user} />,
    },
    {
      key: 'account',
      label: 'Account',
      children: <AccountSettings user={user} />,
    },
  ];

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      destroyOnHidden
      width={720}
      title=""
      styles={{
        content: {
          padding: 0,
        },
        body: {
          padding: 0,
        },
      }}
    >
      <Styles.ModalLayout>
        <Styles.ModalHeader>
          <div>
            <Typography.Title level={4} style={{ margin: 0 }}>
              Settings
            </Typography.Title>
            <Typography.Text type="secondary">
              Manage workspace preferences and context.
            </Typography.Text>
            {release ? (
              <Typography.Text type="secondary" style={{ display: 'block' }}>
                Version {release}
              </Typography.Text>
            ) : null}
          </div>
        </Styles.ModalHeader>
        <Styles.ModalBody>
          <Tabs tabPosition="left" items={items} style={{ minHeight: 320 }} />
        </Styles.ModalBody>
      </Styles.ModalLayout>
    </Modal>
  );
};

export default SettingsModal;
